import {
  BankIcon,
  BirjaIcon,
  LocationIcon,
  MaterialControl,
  AgroportalIcon,
  AgrosubsidiyaIcon,
  InsuranceIcon,
  // AgrosubsidiyaIcon,
} from '@/common/icons';
import { SidebarProps } from '@/common/models/ISidebar';
import {
  BarChart3,
  Building2,
  // Building2, // Klasterlar sahifasi ochilganda qaytariladi
  Leaf,
  Satellite,
  Sprout,
  User,
  UserCheck2Icon,
  Users,
} from 'lucide-react';
import { ROUTES } from './routes';
import { useUserInfo } from '@/hooks/useUserInfo';
import { PAGE_PERMISSIONS, PermissionCode } from './permissions';

export const useSidebar = () => {
  const { data: userInfo } = useUserInfo();
  const permissions = userInfo?.permissions || [];
  const hasPermission = (key: PermissionCode) =>
    permissions ? permissions.includes(key) : false;
  const hasAnyPermission = (requiredPermissions: readonly PermissionCode[]) =>
    requiredPermissions.some(hasPermission);
  const sidebar: SidebarProps[] = [
    {
      id: ROUTES.PROFILE,
      title: 'profile',
      href: `/${ROUTES.PROFILE}`,
      Icon: User,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-blue-50',
      is_view: true,
    },
    // {
    //   id: ROUTES.HOME,
    //   title: 'dashboard',
    //   href: ROUTES.HOME,
    //   Icon: DashboardIcon,
    //   with_auth: false,
    //   isOpen: true,
    //   bgColor: 'bg-blue-50',
    // },
    {
      id: ROUTES.LAND_AREA,
      title: 'land_area',
      href: `/${ROUTES.LAND_AREA}`,
      Icon: LocationIcon,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-green-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.LAND),
    },
    {
      id: ROUTES.COSMIC_MONITORING,
      title: 'cosmic_monitoring',
      href: ROUTES.COSMIC_MONITORING,
      Icon: Satellite,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-green-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.COSMIC_MONITORING),
    },
    {
      id: ROUTES.BIRJA,
      title: 'exchange',
      href: ROUTES.BIRJA,
      Icon: BirjaIcon,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-orange-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.BURSE),
    },
    {
      id: ROUTES.BANK,
      title: 'bank',
      href: ROUTES.BANK,
      Icon: BankIcon,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-purple-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.BANK),
    },
    // {
    //   id: ROUTES.FUNDING_CONTROL,
    //   title: 'funding_control',
    //   href: ROUTES.FUNDING_CONTROL,
    //   Icon: FaundingControl,
    //   with_auth: false,
    //   isOpen: true,
    //   bgColor: 'bg-red-50',
    // },
    {
      id: ROUTES.MATERIAL_CONTROL,
      title: 'material_resource_control',
      href: ROUTES.MATERIAL_CONTROL,
      Icon: MaterialControl,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-blue-55',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.MATERIAL_CONTROL),
    },
    {
      id: ROUTES.HARVEST,
      title: 'harvest',
      href: ROUTES.HARVEST,
      Icon: Leaf,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-green-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.HARVEST),
      childrens: [
        {
          id: ROUTES.HARVEST_STATISTICS,
          title: 'harvest_statistics',
          href: `/${ROUTES.HARVEST_STATISTICS}`,
          Icon: BarChart3,
          with_auth: false,
          isOpen: true,
          bgColor: 'bg-green-50',
        },
        // Klasterlar sahifasi hozircha yopiq — tayyor bo'lgach ochiladi.
        {
          id: ROUTES.HARVEST_CLUSTERS,
          title: 'harvest_clusters',
          href: `/${ROUTES.HARVEST_CLUSTERS}`,
          Icon: Building2,
          with_auth: false,
          isOpen: true,
          bgColor: 'bg-green-50',
        },
        {
          id: ROUTES.HARVEST_LOCATIONS,
          title: 'harvest_locations',
          href: `/${ROUTES.HARVEST_LOCATIONS}`,
          Icon: LocationIcon,
          with_auth: false,
          isOpen: true,
          bgColor: 'bg-green-50',
        },
      ],
    },
    {
      id: ROUTES.AGROPORTAL,
      title: 'agroportal',
      href: ROUTES.AGROPORTAL,
      Icon: AgroportalIcon,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-purple-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.AGROPORTAL),
    },
    {
      id: ROUTES.AGROSUBSIDIYA,
      title: 'agrosubsidiya',
      href: ROUTES.AGROSUBSIDIYA,
      Icon: AgrosubsidiyaIcon,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-purple-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.AGROSUBSIDIYA),
    },
    {
      id: ROUTES.INSURANCE,
      title: 'insurance',
      href: ROUTES.INSURANCE,
      Icon: InsuranceIcon,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-blue-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.INSURANCE),
    },
    {
      id: ROUTES.SEEDS,
      title: 'seeds',
      href: ROUTES.SEEDS,
      Icon: Sprout,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-green-50',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.SEEDS),
    },
    {
      id: ROUTES.ROLES,
      title: 'roles',
      href: ROUTES.ROLES,
      Icon: UserCheck2Icon,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-blue-55',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.ROLES.INDEX),
    },
    {
      id: ROUTES.USERS,
      title: 'users',
      href: ROUTES.USERS,
      Icon: Users,
      with_auth: false,
      isOpen: true,
      bgColor: 'bg-blue-55',
      is_view: hasAnyPermission(PAGE_PERMISSIONS.USERS.INDEX),
    },
  ];
  const SIDEBAR = sidebar.filter((item) => item.is_view);
  return {
    SIDEBAR,
  };
};
